// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3wwdu","title":"AfterBackImages_title__3p7u0","images":"AfterBackImages_images__2GaTA"};